module.exports = __webpack_public_path__ + "media/cuk/cuk_car@3x-65d46d42.svg";